import React, { useEffect, useMemo } from "react";

import {
  Context,
  POST_LESSON_COMPLETED_SUCCESS_MESSAGE,
  createTeachingMaterialViewLog,
  fetchLesson,
  fetchCompletionStatuses,
  fetchLessonRetrospectives,
  postCompletedLesson,
  postLessonRetrospectives,
  fetchOnePagePortfolioAssessment,
  fetchTeachingMaterial,
  fetchOnePagePortfolioAssessmentAnswersVisibility,
} from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import MaterialForImage from "../../../templates/teacher/MaterialForImage";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const teachingMaterialId = parseInt(parseQueryParams()["teachingMaterial"]);
  const classListInParams = parseQueryParams()["classList"];
  const lessonId = parseInt(parseQueryParams()["lesson"]);
  const pageNo = parseInt(parseQueryParams()["page"]);
  // レンダリングのたびにclassListが異なるメモリに作成され
  // 再度useEffect内の処理が実行してしまうためメモ化
  const classList = useMemo<number[]>(
    () =>
      classListInParams
        ? classListInParams.split(",").map((classID: string) => Number(classID))
        : [],
    [classListInParams],
  );

  useEffect(() => {
    dispatch(fetchLesson(lessonId));
    const classIDs = classListInParams
      ? classListInParams.split(",").map((classID: string) => Number(classID))
      : [];
    dispatch(
      createTeachingMaterialViewLog(
        teachingMaterialId,
        lessonId,
        pageNo,
        JSON.stringify(classIDs),
      ),
    );
  }, [dispatch, lessonId, teachingMaterialId, pageNo, classListInParams]);

  useEffect(() => {
    dispatch(fetchCompletionStatuses(classList, lessonId));
    dispatch(fetchLessonRetrospectives(classList.join(), lessonId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, lessonId]);

  useEffect(() => {
    if (state.lesson_completed === POST_LESSON_COMPLETED_SUCCESS_MESSAGE) {
      dispatch(fetchCompletionStatuses(classList, lessonId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, state.lesson_completed, lessonId]);

  useEffect(() => {
    dispatch(fetchTeachingMaterial(teachingMaterialId));
  }, [dispatch, teachingMaterialId]);

  const postCompletedLessonFunc = () => {
    dispatch(postCompletedLesson(classList, lessonId));
  };

  const postCompletedLessonRetrospectivesFunc = (
    score: number,
    lessonDeliveryScore: number,
    groupWorkScore: number | null,
  ) => {
    dispatch(
      postLessonRetrospectives(
        state.teacher.id,
        classList.join(),
        lessonId,
        score,
        lessonDeliveryScore,
        groupWorkScore,
      ),
    );
  };

  const fetchOnePagePortfolioAssessmentFunc = (id: number) => {
    dispatch(fetchOnePagePortfolioAssessment(id));
  };

  const fetchOnePagePortfolioAssessmentAnswersVisibilityFunc = (
    id: number,
    classList: number[],
  ) => {
    dispatch(fetchOnePagePortfolioAssessmentAnswersVisibility(id, classList));
  };

  return state.lesson && state.lesson.id === lessonId ? (
    <MaterialForImage
      teachingMaterialId={teachingMaterialId}
      lesson={state.lesson}
      classList={classList}
      nextLessonId={state.next_lesson_id}
      prevLessonId={state.prev_lesson_id}
      postCompletedLesson={postCompletedLessonFunc}
      postCompletedLessonRetrospectives={postCompletedLessonRetrospectivesFunc}
      fetchOnePagePortfolioAssessment={fetchOnePagePortfolioAssessmentFunc}
      fetchOnePagePortfolioAssessmentAnswersVisibility={
        fetchOnePagePortfolioAssessmentAnswersVisibilityFunc
      }
    />
  ) : null;
};
